import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import Divider from 'material-ui/Divider';
import { addFeedback, clearFeedbackError } from '../../redux';
import TextField from 'material-ui/TextField';

function Contact (props) {
    const {
        clearFeedbackError,
        user,
        addFeedback,
        feedbackError,

    } = props;

    const [subject, setSubject] = useState("");
    const [text, setText] = useState("");
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const [errMessage, setErrMessage] = useState("");

    useEffect(() => {
        clearFeedbackError();
        setEmail(user.email);
    }, []);

    const handleChangeEmail = (e) => {
        setEmail(e.target.value);
    }

    const handleChangeSubject = (e) => {
        setSubject(e.target.value);
    }

    const handleChangeText = (e) => {
        setText(e.target.value);
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        if (text === "" || subject === "") {
            setErrMessage("Please fill out both the subject and text fields.");
        } 

        addFeedback({subject, text, email});
        
        setSubject("");
        setText("");
        setMessage("Your message has been sent.");
        setErrMessage("");

        if(user.email === ""){
            setEmail("");
        }
    }

    
    useEffect(() => {
        if (feedbackError && !errMessage) {
            setErrMessage("Something went wrong. Make sure you typed in a valid email address. If the problem persists, try again later.");
            setMessage("");
        }
    }, [feedbackError, errMessage])
    

    return (
        <div className="inputPageContainer">
            <div className="inputPage">
                <h1>Contact Us</h1>
                <h2>We would love to hear from you! We'll reach out as soon as we can.</h2>
                <form onSubmit={handleSubmit}>
                    {user.email === "" &&
                        <div>
                            <TextField
                                hintText="Email Address"
                                underlineShow={false}
                                className="inputRow"
                                fullWidth={true}
                                name="email"
                                value={email}
                                onChange={handleChangeEmail}
                            />
                            <Divider />
                        </div>
                    }
                    <TextField
                        hintText="Subject"
                        underlineShow={false}
                        className="inputRow"
                        fullWidth={true}
                        name="subject"
                        value={subject}
                        onChange={handleChangeSubject}
                    />
                    <Divider />
                    <TextField
                        hintText="Feedback"
                        underlineShow={false}
                        className="inputRow"
                        fullWidth={true}
                        name="text"
                        value={text}
                        onChange={handleChangeText}
                        multiLine={true}
                        rows={1}
                    />
                    <Divider />
                    <button className="pink contactButton">Send</button>
                </form>
                <p className="errorMessage">{errMessage}</p>
                <p>{message}</p>
            </div>
        </div>
    );
}

export default connect(state => state.root, { addFeedback, clearFeedbackError })(Contact);
